import { CommonProductModel, QteTypes } from '~/core/models';

export const buildQteAttributes = (product: CommonProductModel): QteTypes => ({
  qteCode: product.qteCode,
  qteCodeId: product.qteCodeId,
  qteSubCode: product.qteSubCode,
  qteSubCodeId: product.qteSubCodeId,
  qteTypeCode: product.qteTypeCode,
  qteTypeId: product.qteTypeId,
});
